import {actions} from "../../utils/constants";
const initialState = {
    readCustomerInfo:false
}

const ReadCustomerInfoReducer = (state =  initialState , action) => {
    switch (action.type) {
        case actions.READ_CUSTOMER_INFO:
            return { ...state, readCustomerInfo: action.payload }
        default:
            return { ...state }
    }
}

export default ReadCustomerInfoReducer;